import type { ReactNode } from "react";
import styles from "./Comment.module.css";

type CommentProps = {
  children: ReactNode;
  preserveWhitespace?: boolean;
};

const Comment = ({ children, preserveWhitespace = false }: CommentProps) => (
  <div className={[styles.comment, preserveWhitespace && styles.preserveWhitespace].filter(Boolean).join(" ")}>{children}</div>
);

export default Comment;
